__turbopack_context__.v({
  "spin": "LoadingSpinner-module-scss-module__wMsaaW__spin",
  "spinner": "LoadingSpinner-module-scss-module__wMsaaW__spinner",
});
